import { addDays } from './date';
import { isBrowser } from './isBrowser';

interface CookieOptions {
  days?: number;
  hours?: number;
  minutes?: number;
  separator?: string;
}
export function setCookie(name: string, values: string | string[], options?: CookieOptions) {
  const value = (Array.isArray(values) ? values : [values]).join(',');
  let expires = '';
  if (options) {
    let date = new Date();
    if (options.days) {
      date = addDays(date, options.days);
    }
    if (options.hours) {
      const HOURS = 24;
      date = addDays(date, options.hours * HOURS);
    }
    if (options.minutes) {
      const MINUTES = 1440;
      date = addDays(date, options.minutes * MINUTES);
    }
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
}

export function getCookieByKey(
  name: string,
  options?: Pick<CookieOptions, 'separator'>
): string | string[] | undefined {
  if (isBrowser() === false) {
    return undefined;
  }

  const nameEQ = `${name}=`;
  const cookie = document.cookie
    .split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.indexOf(name) === 0);

  if (!cookie) {
    return undefined;
  }

  return options && options.separator
    ? cookie.substring(nameEQ.length).split(options.separator)
    : cookie.substring(nameEQ.length);
}

export function removeCookie(name: string) {
  document.cookie = `${name}=; Max-Age=-99999999;`;
}
